import { useEffect, useState } from 'react'
import { IconStar } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'
import { getTestimonialsByLanguage } from '@/content/testimonials'

// Little testimonial on the bottom left on sign in page / account confirm page
export function TestimonialSection() {
  const { t, i18n } = useTranslation()
  const [testimonial, setTestimonial] = useState('')
  const [gradient, setGradient] = useState('from-blue-400 to-purple-500')

  useEffect(() => {
    // Filter testimonials under 200 characters
    const testimonials = getTestimonialsByLanguage(i18n.language);
    const shortTestimonials = testimonials.filter(t => t.content.length < 200)

    // Only proceed if we have short testimonials
    if (shortTestimonials.length > 0) {
      const randomTestimonialIndex = Math.floor(Math.random() * shortTestimonials.length)
      const selected = shortTestimonials[randomTestimonialIndex]
      setTestimonial(selected?.content || '')
    }

    const gradients = [
      'from-blue-400 to-purple-500',
      'from-pink-500 to-orange-400',
      'from-green-400 to-cyan-500',
      'from-purple-500 to-pink-500',
      'from-yellow-400 to-orange-500',
      'from-blue-500 to-teal-400',
    ]
    const randomGradient = gradients[Math.floor(Math.random() * gradients.length)]
    setGradient(randomGradient)
  }, [i18n.language])

  return (
    <div className="flex flex-col gap-3 max-w-xs">
      <p className="text-xs lg:text-sm leading-normal lg:leading-normal text-slate-500 lg:text-slate-200">
        {testimonial}
      </p>
      <div className="flex gap-1 mb-3">
        <IconStar className="w-3 h-3 fill-yellow-300 text-yellow-300" />
        <IconStar className="w-3 h-3 fill-yellow-300 text-yellow-300" />
        <IconStar className="w-3 h-3 fill-yellow-300 text-yellow-300" />
        <IconStar className="w-3 h-3 fill-yellow-300 text-yellow-300" />
        <IconStar className="w-3 h-3 fill-yellow-300 text-yellow-300" />
      </div>
      <div className="flex items-center gap-2">
        <div className={`w-4 h-4 rounded-full bg-gradient-to-br ${gradient}`} />
        <p className="text-xs lg:text-sm leading-normal lg:leading-normal text-slate-400">
          {t('auth.appStoreReview')}
        </p>
      </div>
    </div>
  )
}